<div class="login login-with-news-feed">
  <div class="right-content">
    <div class="login-header text-center">
      <div class="brand">
        <img src="/images/Bunge-REV-CMYK.svg" class="img-fluid" alt="Bunge" style="padding: 2em" />
      </div>
    </div>
    <div class="login-content text-center">
      <div class="login-buttons">
        <button class="btn btn-accent btn-block btn-lg" (click)="login()">
          Sign in or Sign up
        </button>
      </div>
      <div class="d-none d-md-block m-t-40 p-t-40">
        <hr />
        <p class="text-center text-grey-darker">
          &copy; 2025 Bunge
        </p>
      </div>
    </div>
  </div>

  <div class="news-feed">
    <div class="news-image"></div>
    <div class="news-caption">
      <div class="row">
        <div class="col-md-6 col-lg-4 col-xl-4">
          <div class="news-caption-header">
            <img src="/images/Bunge-REV-CMYK.svg" alt="Bunge" class="news-feed-logo" />
          </div>
        </div>
      </div>
      <div class="row news-caption-body">
        <div class="col-md-6 col-lg-4 col-xl-4">
          <div class="login-box-info text-grey-darker">
            <p>Welcome to myBunge, previously myViterra. Users can access their former Viterra account information including
              contracts, scale tickets, and more.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
